export type SiteAppearancePublic = {
  accentLocked: boolean;
  lockedPrimaryHue?: string;
  defaultBg: 'light' | 'dim' | 'lights-out';
  backgroundImageUrl?: string;
  backgroundScope?: 'home' | 'site';
  /** When false, only community admins may create public/private groups. Default true. */
  memberGroupCreationEnabled?: boolean;
};

export type SiteAppearanceAdmin = Omit<SiteAppearancePublic, 'memberGroupCreationEnabled'> & {
  memberGroupCreationDisabled?: boolean;
  updatedAt?: string;
  updatedByAdminId?: string;
};

export const SITE_APPEARANCE_STORAGE_KEY = 'communio_site_appearance';

export const SITE_APPEARANCE_DEFAULT: SiteAppearancePublic = {
  accentLocked: false,
  defaultBg: 'light',
  backgroundScope: 'home',
  memberGroupCreationEnabled: true,
};

/** Public uses enabled; admin uses disabled storage flag. */
export function memberGroupCreationAllowed(a: {
  memberGroupCreationEnabled?: boolean;
  memberGroupCreationDisabled?: boolean;
}): boolean {
  if (typeof a.memberGroupCreationDisabled === 'boolean') {
    return !a.memberGroupCreationDisabled;
  }
  return a.memberGroupCreationEnabled !== false;
}
